import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { useStripe, useElements, CardNumberElement } from '@stripe/react-stripe-js';

import AddressAndTaxIdGroup from './AddressAndTaxIdGroup';
import CardGroup from './CardGroup';

axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('[name=csrf-token]').content;

function Form({setupIntentClientSecret, formData, translations, links}) {
  const { handleSubmit, register, errors, setError, clearError } = useForm({
    defaultValues: {
      form_data: {
        full_name: formData.fullName,
        company_name: formData.companyName,
        street_address: formData.streetAddress,
        city: formData.city,
        postal_code: formData.postalCode,
        country_code: formData.countryCode,
        tax_id: formData.taxId
      }
    }
  });
  const stripe = useStripe();
  const elements = useElements();
  const [isSubmitted, setIsSubmitted] = useState(false);

  const onSubmit = async (data) => {
    if (!stripe || !elements) {
      return;
    };

    setIsSubmitted(true);

    const apiResult = await axios.request({
      url: '/panel/settings/billing_informations',
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      data: {
        form_data: {
          full_name: data.form_data.full_name,
          company_name: data.form_data.company_name,
          street_address: data.form_data.street_address,
          city: data.form_data.city,
          postal_code: data.form_data.postal_code,
          country_code: data.form_data.country_code,
          tax_id: data.form_data.tax_id,
          agreement: data.form_data.agreement
        }
      }
    })

    if (apiResult.data.errors !== undefined) {
      var convertedErrors = []

      for (var key in apiResult.data.errors) {
        convertedErrors.push({
          type: '',
          name: 'form_data_' + key,
          message: apiResult.data.errors[key][0]
        });
      }

      setIsSubmitted(false);
      setError(convertedErrors);
    } else {
      const stripeResult = await stripe.confirmCardSetup(setupIntentClientSecret, {
        payment_method: {
          card: elements.getElement(CardNumberElement),
          billing_details: {
            name: data.form_data.full_name
          }
        }
      });

      if (stripeResult.error !== undefined) {
        setIsSubmitted(false);
        setError([{
          type: '',
          name: 'form_data_card_number',
          message: stripeResult.error.message
        }]);
      } else {
        window.location.href = apiResult.data.redirect_url;
      }
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="form" id="billing-form">
      <AddressAndTaxIdGroup register={register} errors={errors} translations={translations} />
      <CardGroup register={register} errors={errors} translations={translations} />

      <div className="row col-10 col-sm-9 mx-auto px-0 px-sm-4 mt-4 mb-4">
        <div className="checkbox mx-auto">
          <input ref={register} name="form_data[agreement]" id="form_data_agreement" type="checkbox" />
          <label htmlFor="form_data_agreement">
            {translations.accept}
            &nbsp;
            <a href={links.termsAndConditionsPath} className="text-underlined show-terms2" target="_blank">{translations.terms}</a>
          </label>
          {errors.form_data_agreement ? <span className="input__text text-danger">{errors.form_data_agreement.message}</span> : ''}
          <br/>
        </div>
      </div>
      <div className="form__group mb-5">
        <button disabled={!stripe || !elements || isSubmitted} className="btn btn--primary btn--block col-10 col-sm-9 mx-auto" type="submit">
          {isSubmitted ? <i className="fa fa-spinner fa-spin"></i> : translations.submit}
        </button>
      </div>
      <div className="text-center">
        <a className="go-back" href={links.goBackUrl}>
          {translations.goBack}
          <svg className="icon--arrow-down">
            <use xlinkHref={links.spriteImageUrl + "#icon--arrow-down"}></use>
          </svg>
        </a>
      </div>
    </form>
  );
};

export default Form;
